import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from "react";

type BreadcrumbLabelContextValue = {
  lastLabelOverride?: string;
  setLastLabelOverride: (label: string | undefined) => void;
};

const BreadcrumbLabelContext = createContext<BreadcrumbLabelContextValue | null>(
  null,
);

export function BreadcrumbLabelProvider({ children }: { children: ReactNode }) {
  const [lastLabelOverride, setLastLabelOverrideState] = useState<
    string | undefined
  >();

  const setLastLabelOverride = useCallback((label: string | undefined) => {
    setLastLabelOverrideState(label);
  }, []);

  const value = useMemo(
    () => ({ lastLabelOverride, setLastLabelOverride }),
    [lastLabelOverride, setLastLabelOverride],
  );

  return (
    <BreadcrumbLabelContext.Provider value={value}>
      {children}
    </BreadcrumbLabelContext.Provider>
  );
}

export function useBreadcrumbLabelContext() {
  return useContext(BreadcrumbLabelContext);
}

/** ຕັ້ງຊື່ crumb ສຸດທ້າຍ (ເຊັ່ນ ເລກທີເອກະສານ) — clear ເມື່ອ unmount */
export function useBreadcrumbPageLabel(label: string | undefined) {
  const ctx = useBreadcrumbLabelContext();
  const set = ctx?.setLastLabelOverride;

  useEffect(() => {
    if (!set) return;
    set(label);
    return () => set(undefined);
  }, [label, set]);
}
